import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../data.service';
import { environment } from '../environments';

@Component({
  selector: 'app-business-profile',
  templateUrl: './business-profile.component.html',
  styleUrls: ['./business-profile.component.css']
})
export class BusinessProfileComponent implements OnInit {

  businessCard : any = false
  loading : boolean = true;
  hasError : boolean = false;
  id : any = ''
  path: any = environment.API_URL

  constructor(
    private dataService: DataService,
    private activatedRoute : ActivatedRoute
  ) { }


  ngOnInit() {

    this.activatedRoute.params.subscribe((params) => {
      this.id = params.token;
      this.getBusinessCard();
    })

  }

  getBusinessCard () {
    this.dataService.__post('/user/business', {id : this.id})
    .subscribe(
      (success) => {
        setTimeout(()=>{
          this.loading = false;
          this.businessCard = success
        },2000)
      },
      (error) => {
        this.loading = false;
        this.hasError = true;
      }
    )
  }

}
